import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const IndividualProjectGraphsStyles = css`
  ${MainStyles}

  .full-height-tab {
    height: 100%;
    padding-top: 10px;
  }

  .container {
    width: 100%;
    height: auto;
    min-width: 920px;
  }

  .auto-height {
    height: 100%;
  }

  .chartTab {
    font-size: smaller;
  }
`;
